import { makeAutoObservable } from 'mobx';
import { clearPersistedStore, makePersistable } from 'mobx-persist-store';

class ListStore {
  params = JSON.stringify({});

  defaultStateValues = {
    paginationState: {
      pageIndex: 0,
      pageSize: 10,
    },
    filters: [],
    sortingState: [],
  };

  constructor(rootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this);

    makePersistable(this, {
      name: 'ListStore',
      properties: ['params'],
    });
  }

  getListValue(value) {
    return {
      paginationState: {
        ...this.defaultStateValues.paginationState,
        ...value?.paginationState,
      },
      sortingState: [
        ...this.defaultStateValues.sortingState,
        ...(value?.sortingState || []),
      ],
      filters: [...(value?.filters || [])],
    };
  }

  reset(key) {
    const current = JSON.parse(this.params);
    const newData = {
      ...current,
      [key]: {
        paginationState: this.defaultStateValues.paginationState,
        sortingState: this.defaultStateValues.sortingState,
        filters: [],
      },
    };
    this.params = JSON.stringify(newData);
  }

  set(key, value) {
    if (value) {
      const current = JSON.parse(this.params);

      const newValue = this.getListValue(value);

      const newData = {
        ...current,
        [key]: newValue,
      };
      this.params = JSON.stringify(newData);
    }
  }

  get(key, defaultStateValues = null) {
    const data = JSON.parse(this.params);
    if (!data?.[key]) {
      this.set(key, defaultStateValues || {});
    }
    return data?.[key] || this.defaultStateValues;
  }

  async clearStore() {
    await clearPersistedStore(this);
  }
}

export default ListStore;
